import React from "react";
import NavBis from "../../components/NavBis/NavBis";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const Matches = () => {
  return (
    <div>
      <Navbar />
      <br /> <br />
      <NavBis />
      <br />
      <div
        id="wg-api-football-games"
        data-host="v3.football.api-sports.io"
        data-key="bb124505cd72755d98cd4b1fe70500b7"
        data-date=""
        data-league="1"
        data-season="2022"
        data-theme=""
        data-refresh="0"
        data-show-toolbar="false"
        data-show-errors="false"
        data-show-logos="true"
        data-modal-game="true"
        data-modal-standings="true"
        data-modal-show-logos="true"
      ></div>
      <br /> <br />
      <Footer />
    </div>
  );
};

export default Matches;
